// #583 — people/ride icons were reversed. RiderIcon (nav "People") now draws
// the single-rider glyph; RideIcon draws the horse-and-rider ("ride") glyph.
// Bodies swapped so each component name matches the glyph it renders (nav
// usage in App.jsx stays: RiderIcon→people, RideIcon→rides).
const RiderIcon = (props) => {
  return (
    <svg
      xmlns="http://www.w3.org/2000/svg"
      fill="currentColor"
      viewBox="0 0 1200 1200"
      width="1.5rem"
      height="1.5rem"
      {...props}
    >
      <path d="m834.84 672.6c-2.6094-2.6523-5.418-5.0977-8.3984-7.3203l-108.12 126.72c14.145 8.9453 25.367 21.836 32.281 37.078l111-129.84c-8.5234-8.3984-17.523-17.277-26.762-26.637z" />
      <path d="m636 786-102-170.04c-21.602 0-38.398 1.3203-47.039 1.6797h-5.3984l-7.4414 1.5586 121.56 204c9.0977-16.406 23.234-29.449 40.32-37.199z" />
      <path d="m789.96 173.04c-2.625-21.961-15.414-41.414-34.535-52.531-19.117-11.121-42.352-12.613-62.734-4.0312-20.387 8.582-35.559 26.238-40.973 47.684 10.559 0 21.121-0.83984 32.039-0.83984h0.003907c35.629-0.16406 71.191 3.0898 106.2 9.7188z" />
      <path d="m182.52 659.28c3.2227-0.035156 6.4336-0.35547 9.6016-0.96094l278.52-56.398c-17.879-81.359-175.68-92.641-177.24-92.762h-0.003906c-0.95703-0.054687-1.8945-0.29688-2.7578-0.71875-28.082 7.5586-98.641 30.117-140.88 73.918-8.1016 8.6758-12.512 20.16-12.301 32.027 0.21484 11.871 5.0352 23.188 13.445 31.566s19.746 13.156 31.613 13.328z" />
      <path d="m489.24 597.96c0.0625 0.55859 0.0625 1.1211 0 1.6797 13.68-0.71875 40.801-1.9219 74.641-1.9219 91.32 0 231.36 9 283.8 62.281 58.801 60 113.4 109.2 150.96 109.2 6.6133 0.015625 13.105-1.7617 18.789-5.1445 5.6836-3.3789 10.348-8.2383 13.492-14.055 32.758-52.078 125.28-568.68-346.92-568.68-335.04 0-375.48 246.96-380.4 309.72 35.637 3.6016 167.28 22.801 185.64 106.92z" />
      <path d="m642 945v135h60v-135c-9.6602 3.6641-19.91 5.5352-30.238 5.5195-10.176-0.023437-20.258-1.8945-29.762-5.5195z" />
      <path d="m740.4 864.36c0 37.645-30.516 68.16-68.16 68.16-37.641 0-68.16-30.516-68.16-68.16s30.52-68.16 68.16-68.16c37.645 0 68.16 30.516 68.16 68.16z" />
    </svg>
  );
};

export default RiderIcon;
